import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class AboutV2 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

           let SectionClass = this.props.sectionclass ? this.props.sectionclass : ''

    return <div className={"about-area pd-top-120 go-top "+SectionClass}>
			  <div className="container">
			    <div className="about-area-inner">
			      <div className="row">
			        <div className="col-lg-12 col-md-10">
						<img src={publicUrl+"assets/img/website/madras-institute-of-engineering-and-technology-kodambakkam.jpg"} alt="img" />
			        </div>
			        <div className="col-lg-12">
			          <div className="about-inner-wrap">  
			            <div className="section-title mb-0">
			              {/* <h6 className="sub-title right-line">ABOUT US</h6> */}
						  <h1 style={{fontSize: '20px'}}>Top Coaching Institute in Chennai</h1>
			              <h2 className="title">Madras Institute of Engineering Technology</h2>
						  <p>A Unit of VINAYAKA TRUST (Regd.)</p>
			              <p className="content textJustify">The ‘Madras Institute of Engineering Technology’ (M.I.E.T.) was established in the year 1989 which is a unit of Vinayaka Trust. It is committed to the cause of training students to upgrade their competence with rich knowledge and make them to cope up with the challenges of technology. MIET renders valuable service in channelizing the deserving students who are denied the privilege to pursue his/her education in the field of his choice. Students from all over India and other foreign countries have registered here: besides distance learning programmers are available to encourage the professionals for higher studies without disturbing their normal work schedule. </p>
			              <p className="content textJustify">The MIET Group of Institutions appreciate your decision to upgrade your competence by enrolling in our specialized programs. This prospectus provides you all the essential information, advice and guidance in choosing a course which is at par with the emerging trends. We offer coaching for Engineering, Under Graduates & Diploma. Our infrastructure facilities are par excellence and include state- of the art laboratories, library, hostel etc. After completing the course, you will get numerous job opportunities both in India and abroad. You are requested to preserve this prospectus till you complete the course. Our best wishes to you to emerge as a trained professional in the field of engineering & technology.</p>
			            </div>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>
        }
}

export default AboutV2